import React from "react";

const Loader = ({ size = "medium", text = "Loading...", className = "" }) => {
  const sizeClasses = {
    small: "ps-loader-small",
    medium: "ps-loader-medium",
    large: "ps-loader-large",
  };

  return (
    <div className={`ps-loader-wrapper ${className}`}>
      <div className={`ps-loader-circle ${sizeClasses[size]}`} />
      {text && <p className="ps-loader-text">{text}</p>}
    </div>
  );
};

export default Loader;
